import { render, staticRenderFns } from "./videoConfBase.vue?vue&type=template&id=3ad64832&scoped=true&lang=pug"
import script from "./videoConfBase.vue?vue&type=script&lang=js"
export * from "./videoConfBase.vue?vue&type=script&lang=js"
import style0 from "./videoConfBase.vue?vue&type=style&index=0&id=3ad64832&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad64832",
  null
  
)

export default component.exports